import React from 'react';
import Link from 'next/link';

import TriangleAlertIcon from 'public/icons/triangle-alert.svg';
import styles from 'styles/components/profileVerification/VerificationAlert.module.scss';

const MiniAlert = ({ description }) => (
  <div className={styles.container} style={{ top: 0 }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div className={styles.iconContainer}>
        <TriangleAlertIcon />
      </div>

      <h2>Attention required</h2>
    </div>

    <p className={styles.description}>{description}</p>
  </div>
);

export default MiniAlert;
